import { getHttpClient } from "@/core/api";

export async function getVersion() {
  const response = await getHttpClient().get("v2/version");
  return response.data;
}
